import { NodeType, randomDhtAddress, toDhtAddressRaw } from '@streamr/dht';
import { createNetworkNode, } from '@streamr/trackerless-network';
import { ContentType, EncryptionType, SignatureType, } from '@streamr/trackerless-network';
import { StreamPartIDUtils, hexToBinary, } from '@streamr/utils';
import EventEmitter from 'eventemitter3';
import { Message } from '../../proto/messages';
const globalEntryPoints = [
    {
        nodeId: hexToBinary('6f5b53812fd9cc07f225a0b3a6aa5b96672e852e'),
        websocket: {
            host: 'polygon-entrypoint-4.streamr.network',
            port: 443,
            tls: true,
        },
        type: NodeType.NODEJS,
    },
    {
        nodeId: hexToBinary('16dcfb6078e54567435c6bee8907f5e4f5d65a1b'),
        type: NodeType.NODEJS,
        websocket: {
            host: 'streamrtv-entrypoint-1.streamr.network',
            port: 443,
            tls: true,
        },
    },
    {
        nodeId: hexToBinary('d32a023fbb60efd874211d9d5718ddbfa1e3cb1c'),
        type: NodeType.NODEJS,
        websocket: {
            host: 'streamrtv-entrypoint-2.streamr.network',
            port: 443,
            tls: true,
        },
    },
];
// TODO: fix this to work the same way as in the normal Streamr network
let sequenceNumber = 0;
const createStreamMessage = (streamPartId, publisherId, message) => {
    const streamMessage = {
        messageId: {
            streamId: StreamPartIDUtils.getStreamID(streamPartId),
            streamPartition: StreamPartIDUtils.getStreamPartition(streamPartId),
            timestamp: Date.now(),
            sequenceNumber: sequenceNumber++,
            publisherId: publisherId,
            messageChainId: 'msgChainId',
        },
        body: {
            oneofKind: 'contentMessage',
            contentMessage: {
                content: Message.toBinary(message),
                contentType: ContentType.BINARY,
                encryptionType: EncryptionType.NONE,
            },
        },
        signatureType: SignatureType.ECDSA_SECP256K1_EVM,
        signature: hexToBinary('0x1234'),
    };
    return streamMessage;
};
export class StreamrWrapper extends EventEmitter {
    networkNode;
    streamPartId;
    localNodeId = randomDhtAddress();
    localPeerDescriptor = {
        nodeId: toDhtAddressRaw(this.localNodeId),
        type: NodeType.NODEJS,
    };
    constructor() {
        super();
        this.networkNode = createNetworkNode({
            layer0: {
                peerDescriptor: this.localPeerDescriptor,
                entryPoints: globalEntryPoints,
                webrtcAllowPrivateAddresses: true,
                iceServers: [
                    { url: 'stun:stun.streamr.network', port: 5349 },
                    {
                        url: 'turn:turn.streamr.network',
                        port: 5349,
                        username: 'BrubeckTurn1',
                        password: 'MIlbgtMw4nhpmbgqRrht1Q==',
                    },
                    {
                        url: 'turn:turn.streamr.network',
                        port: 5349,
                        username: 'BrubeckTurn1',
                        password: 'MIlbgtMw4nhpmbgqRrht1Q==',
                        tcp: true,
                    },
                    {
                        url: 'turn:turn-us.streamr.network',
                        port: 5349,
                        username: 'BrubeckTurn1',
                        password: 'MIlbgtMw4nhpmbgqRrht1Q==',
                    },
                ],
            },
            networkNode: {
                streamPartitionMinPropagationTargets: 0,
                streamPartitionMaxPropagationBufferSize: 0,
                doNotBufferWhileConnecting: true,
            },
        });
    }
    async start(streamPartIdString) {
        console.log('StreamrWrapper::start()', streamPartIdString);
        await this.networkNode.start();
        this.streamPartId = StreamPartIDUtils.parse(streamPartIdString);
        await this.networkNode.join(this.streamPartId, undefined, {
            plumTreeOptimisation: true,
        });
        this.networkNode.addMessageListener((streamMessage) => {
            if (streamMessage.body.oneofKind === 'contentMessage') {
                const contentMessage = streamMessage.body.contentMessage;
                const message = Message.fromBinary(contentMessage.content);
                if (message.body.oneofKind === 'heartbeat') {
                    this.emit('heartbeat', message.body.heartbeat);
                }
                else if (message.body.oneofKind === 'leave') {
                    this.emit('leave', message.body.leave);
                }
                else if (message.body.oneofKind === 'mediaPacketFragment') {
                    this.emit('mediaPacketFragment', message.body.mediaPacketFragment);
                }
                else if (message.body.oneofKind === 'viewerInfo') {
                    this.emit('viewerInfo', message.body.viewerInfo);
                }
                else {
                    console.error('Unknown message type', message.body.oneofKind);
                }
            }
        });
    }
    async stop() {
        await this.networkNode.stop();
    }
    getNodeId() {
        return this.localNodeId;
    }
    async publishMessage(message) {
        if (this.streamPartId === undefined) {
            throw new Error('Stream part ID is not set');
        }
        const streamMessage = createStreamMessage(this.streamPartId, hexToBinary(this.localNodeId), message);
        await this.networkNode.broadcast(streamMessage, {
            plumTreeOptimisation: true,
        });
    }
    async publishHeartbeat(heartbeat) {
        const message = Message.create({
            messageId: '12334', // TODO: generate a random message id
            body: {
                oneofKind: 'heartbeat',
                heartbeat: heartbeat,
            },
        });
        await this.publishMessage(message);
    }
    async publishLeave(leave) {
        const message = Message.create({
            messageId: '12334', // TODO: generate a random message id
            body: {
                oneofKind: 'leave',
                leave: leave,
            },
        });
        await this.publishMessage(message);
    }
    async publishViewerInfo(viewerInfo) {
        const message = Message.create({
            messageId: '12334', // TODO: generate a random message id
            body: {
                oneofKind: 'viewerInfo',
                viewerInfo: viewerInfo,
            },
        });
        await this.publishMessage(message);
    }
    async publishMediaPacketFragment(mediaPacketFragment) {
        const message = Message.create({
            messageId: '12334', // TODO: generate a random message id
            body: {
                oneofKind: 'mediaPacketFragment',
                mediaPacketFragment: mediaPacketFragment,
            },
        });
        await this.publishMessage(message);
    }
}
